import taskManagerApi from '@/features/shared/services/taskManagerApi';
const buildJobUrl = (resource, action) => {
    return `/${resource}/${action}`;
};
const buildCronUrl = (resource) => {
    return `/${resource}/cron`;
};
export const getJobStatus = async (resource) => {
    const response = await taskManagerApi.get(buildJobUrl(resource, 'status'));
    return response.data.data;
};
export const startJob = async (resource) => {
    const response = await taskManagerApi.post(buildJobUrl(resource, 'start'));
    return response.data.data;
};
export const stopJob = async (resource) => {
    const response = await taskManagerApi.post(buildJobUrl(resource, 'stop'));
    return response.data.data;
};
export const getJobCron = async (resource) => {
    const response = await taskManagerApi.get(buildCronUrl(resource));
    return response.data.data;
};
export const updateJobCron = async (resource, cron) => {
    const response = await taskManagerApi.put(buildCronUrl(resource), { cron });
    return response.data.data;
};
